import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Link from '@material-ui/core/Link';
import AppAvatar from '../../../../core/Avatar/AppAvatar';

const useStyles = makeStyles({
  image: {
    width: '100%',
    height: 'auto',
  },
  skeleton: {
    paddingTop: `${(218 / 690) * 100}%`,
    borderRadius: 25,
    '& > img': {
      display: 'none',
    },
  },
});

interface BannerItemProps {
  src: string;
  alt: string;
  href: string;
  linkProps?: { target?: string; rel?: string; 'data-gtm'?: string };
}

const BannerItem = ({ src, alt, href, linkProps }: BannerItemProps) => {
  const classes = useStyles();
  return (
    <AppAvatar
      src={src}
      loaded
      className={classes.image}
      alt={alt}
      variant="square"
      SkeletonProps={{ className: classes.skeleton }}
      AvatarOnlyProps={{
        component: Link,
        href: href,
        ...linkProps,
      }}
    />
  );
};

export default BannerItem;
